import styled from 'styled-components';
import { Accent, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { font } from 'styles/Global/globalStyles';
import { Radius } from 'styles/Global/objectStyles';
import { Body1Bold, Body4SemiBold, Props } from 'styles/Global/typography';
import DescriptionContainer from './DescriptionContainer';

export default function TotalCard({ target, character, description }: { target: string; character: string; description: string }) {
    return (
        <Container>
            <ContainerHeader>
                <Badge>
                    <Body4SemiBold $color={target === '자녀' ? Accent.color_accent_lime_heavy : Accent.color_accent_purple_heavy}>{target}</Body4SemiBold>
                </Badge>
                <TitleWrapper>
                    <Body1Bold>{character}</Body1Bold>
                </TitleWrapper>
            </ContainerHeader>
            <DescriptionContainer description={description} />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 20px 22px 20px;
    border: 1px solid ${BorderColor.color_border_weak};
    gap: 6px;
    font-family: 'Pretendard', sans-serif;
`;

const ContainerHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    gap: 4px;
    border-radius: ${Radius.radius_12};
`;

const Badge = styled.span`
    display: inline-block;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 700;
    margin: 0;
`;

const SubTitle = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: #444;
`;

export const DescriptionFont = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.regular};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
